

import React, {Component} from 'react';
import { Redirect } from "react-router-dom";


class EmployeeOrderItem extends Component {

    state = {
        redirect : null
    }


    DisplayForOrder = (obj) => {        
        this.setState({ redirect: "/order/" + obj});  
    }

    
    
  render() { 

    
    if (this.state.redirect) {        
        return <Redirect to={this.state.redirect} />
    }  
            
    return (     

        <div className="inner_col">
            <div className="inner_col_htl_img">
                <img src={this.props.employeeOrder.HotelFirstPic}  alt=""/>
            </div>
            <div className="inner_col_htl_main_title_container">
                <div className="inner_col_htl_main_title directionRtl">{this.props.employeeOrder.HotelName}</div>
                <div className="inner_col_htl_sec_title_container">
                    <span className="inner_col_htl_sec_title directionRtl">{this.props.employeeOrder.HotelArea}</span>
                    <span className="inner_col_htl_date marginRight5 directionRtl">
                        {this.props.employeeOrder.EndVacationDateFormatted}
                        -
                        {this.props.employeeOrder.StartVacationDateFormatted}
                        
                    </span>
                </div>
            </div>

            <div className="marginTop14 inner_col_htl_details inner_col_htl_details_font">
                <span className="marginRight24 inner_col_htl_details_2">
                    <img src={"./images/site/night-2.png"} />
                    <span className="directionRtl">
                        {this.props.employeeOrder.TotalNights}
                        &nbsp;
                        לילות

                    </span>
                </span>

                <span className="marginRight15 inner_col_htl_details_2">
                    <img src={"./images/site/room-2.png"} />
                    <span className="directionRtl">
                        {this.props.employeeOrder.RoomsNum}
                        &nbsp;
                        חדרים
                        </span>
                </span>
            </div>

            <div className="inner_col_htl_details inner_col_htl_details_font">
                <span className="marginRight24 inner_col_htl_details_2">
                    <img src={"./images/site/cost-2.png"} alt=""/>
                    <span className="directionRtl">
                        {this.props.employeeOrder.TotalPrice}
                    </span>
                </span>
            </div>

            
            <div className="orderButton" onClick={ () => 
                this.DisplayForOrder(this.props.employeeOrder.Id)}>
                <div className="orderArrow">
                    <img src={"./images/site/arrow-next.png"} alt=""/>                
                </div>
                <div className="orderText">לפרטים</div>
            </div>

        </div>
    )
  }
}

export default EmployeeOrderItem;
